import React, { Component, Fragment } from 'react';
import withStyles from '@mui/styles/withStyles';
import Checkbox from '../../../component/form/Checkbox';
import Grid from '../../../component/form/Grid';
import Label from '../../../component/form/Label';
import Select from '../../../component/form/Select';
import TextField from '../../../component/form/TextField';
import RadioGroup from '../../../component/form/RadioGroup';
import AddressAutocomplete from '../../../component/form/AddressAutocomplete';
import {
    ABORIGINAL_OPTIONS,
    GENDER_OPTIONS,
    PENSION_TYPE_OPTIONS,
    PENSIONER_OPTIONS,
    PLACE_OF_BIRTH_AUSTRALIA,
    PLACE_OF_BIRTH_OPTIONS,
    PLACE_OF_BIRTH_OVERSEAS,
    PLACE_OF_BIRTH_UNKNOWN,
    RESIDENTIAL_ADDRESS_COMPONENTS,
    RETIRED_OPTIONS,
    TORRES_OPTIONS
} from '../../funeral/deceased/DeceasedConstants';
import ColumnLayout from '../../../component/ColumnLayout';
import PhotoModal from '../../../component/form/PhotoModal';
import { joinDefined, stringIsNullOrEmpty } from '../../../util/strings';
import { PreNeedTypes } from '../../quotes/EnquiryConstants';
import ComboListAutoComplete from '../../../component/form/ComboListAutoComplete';
import FileUpload, { getFileName } from '../../../component/form/FileUpload';
import { ImageList, ImageListItem } from '../../../component/form/ImageList';
import { CONTACT_AUS_STATES } from '../../contacts/contactConstants';
import ValidationPlaceholder from '../../../component/form/ValidationPlaceholder';
import { MemorialBookIcon } from '../../../component/IconIndex';

class Identity extends Component {
    state = {
        funeralId: undefined,
        surnameDifferent: null,
        birthplaceUnknown: null,
        bornOverseas: null,
        selectedPhoto: null,
        DateOfBirth: null
    };

    static getDerivedStateFromProps({ form }, { funeralId }) {
        if (!form || !!form.loading) return null;
        if (!!form.fields) {
            const { ID, FamilyNameAtBirth, Surname, PlaceOfBirth1, PlaceOfBirthCountry, DateOfBirth } = form.fields;

            if (ID === funeralId) return null;

            let placeOfBirthOption;

            if (PlaceOfBirth1 === 'Unknown' || !PlaceOfBirthCountry) {
                placeOfBirthOption = PLACE_OF_BIRTH_UNKNOWN;
            } else if (PlaceOfBirthCountry !== 'Australia') {
                placeOfBirthOption = PLACE_OF_BIRTH_OVERSEAS;
            } else {
                placeOfBirthOption = PLACE_OF_BIRTH_AUSTRALIA;
            }

            return {
                funeralId: ID,
                placeOfBirthOption,
                surnameDifferent: !stringIsNullOrEmpty(FamilyNameAtBirth) && FamilyNameAtBirth !== Surname,
                FamilyNameAtBirth,
                PlaceOfBirth1,
                PlaceOfBirthCountry,
                DateOfBirth
            };
        }
        return null;
    }

    onToggleField = (event, fieldList, reversed) => {
        const { form } = this.props;
        const { name, checked } = event.target;

        this.setState({ [name]: !!checked });
        let fields = fieldList;
        if (!Array.isArray(fields)) fields = fields.split(',');

        fields.forEach(field => {
            if (!reversed) {
                form.setField({ [field]: !!checked ? null : this.state[field] });
            } else {
                form.setField({ [field]: !checked ? null : this.state[field] });
            }
        });
    };

    render() {
        const { selectedPhoto } = this.state;
        return (
            <Fragment>
                <PhotoModal photo={selectedPhoto} onClose={() => this.setState({ selectedPhoto: null })} />
                <ColumnLayout>
                    {this.renderFirstColumn()}
                    {this.renderSecondColumn()}
                </ColumnLayout>
            </Fragment>
        );
    }

    renderFirstColumn() {
        const { form, locked } = this.props;
        const { surnameDifferent } = this.state;

        return (
            <Grid container spacing={2}>
                <Grid bucket>
                    <Grid pc={1}>
                        <Select
                            required={true}
                            name="Type"
                            options={PreNeedTypes}
                            form={form}
                            label={'Type of Pre-need'}
                        />
                    </Grid>
                </Grid>
                <Grid bucket>
                    <Grid pc={1}>
                        <Label text="Name" />
                    </Grid>

                    <Grid pc={0.5}>
                        <TextField
                            disabled={locked}
                            name="FirstName"
                            label="First name"
                            form={form}
                            required
                            titleCase
                        />
                    </Grid>

                    <Grid pc={0.5}>
                        <TextField disabled={locked} name="MiddleName" label="Middle name(s)" form={form} titleCase />
                    </Grid>

                    <Grid pc={0.5}>
                        <TextField disabled={locked} name="Surname" label="Surname" form={form} required titleCase />
                    </Grid>

                    <Grid pc={0.5}>
                        <TextField disabled={locked} name="KnownAs" label="Known as" form={form} />
                    </Grid>

                    <Grid pc={1}>
                        <ValidationPlaceholder validationResult={form.getValidation('SurnameAtBirth', true)}>
                            <Grid container spacing={2}>
                                {!!surnameDifferent && (
                                    <Grid pc={0.5}>
                                        <TextField
                                            disabled={locked}
                                            name="FamilyNameAtBirth"
                                            placeholder="Surname at Birth"
                                            form={form}
                                            required={!!surnameDifferent}
                                            onBlur={e =>
                                                this.setState({
                                                    surnameDifferent: !!e.target.value,
                                                    FamilyNameAtBirth: e.target.value
                                                })
                                            }
                                        />
                                    </Grid>
                                )}
                                <Grid pc={surnameDifferent ? 0.5 : 1}>
                                    <Checkbox
                                        disabled={locked}
                                        label="Surname at Birth was different"
                                        checked={!!surnameDifferent}
                                        name={'surnameDifferent'}
                                        onChange={e => this.onToggleField(e, 'FamilyNameAtBirth', 1)}
                                    />
                                </Grid>
                            </Grid>
                        </ValidationPlaceholder>
                    </Grid>

                    <Grid pc={0.5}>
                        <Label text="Gender" htmlFor="select-Gender" />
                        <Select disabled={locked} name="Gender" options={GENDER_OPTIONS} form={form} required />
                    </Grid>

                    <Grid pc={1}>
                        <Label text="Date of Birth" htmlFor="text-DateOfBirth" />
                        <Grid container item spacing={3}>
                            {!form.getField('UnknownDOB') && (
                                <Grid item xs={6} sm={6}>
                                    <TextField
                                        disabled={locked}
                                        name="DateOfBirth"
                                        type="date"
                                        notFuture
                                        form={form}
                                        onBlur={e =>
                                            this.setState({
                                                DateOfBirth: e.target.value
                                            })
                                        }
                                    />
                                </Grid>
                            )}
                            <Grid item xs={6} sm={6}>
                                <Checkbox
                                    disabled={locked}
                                    name="UnknownDOB"
                                    label="Date of Birth unknown"
                                    form={form}
                                    onChange={e => this.onToggleField(e, 'DateOfBirth')}
                                />
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} sm={6} lg={12}>
                        <Label text="Residential Address" htmlFor="ResidentialAddress" />
                        <AddressAutocomplete
                            disabled={locked}
                            id="ResidentialAddress"
                            placeholder="Search for residential address"
                            componentFields={RESIDENTIAL_ADDRESS_COMPONENTS}
                            form={form}
                            allowCustomAddress={true}
                        />
                    </Grid>
                </Grid>
            </Grid>
        );
    }

    renderSecondColumn() {
        const { classes, form, locked } = this.props;

        return (
            <Grid container spacing={2}>
                <Grid bucket>
                    <Grid pc={1}>
                        <Label text="Occupation" htmlFor="text-Occupation" />
                        <ComboListAutoComplete
                            disabled={locked}
                            placeholder="Occupation"
                            name="Occupation"
                            form={form}
                            category={'OCCUPATION'}
                        />
                    </Grid>

                    <Grid pc={1}>
                        <RadioGroup
                            disabled={locked}
                            name="Retired"
                            label="Retired"
                            options={RETIRED_OPTIONS}
                            form={form}
                            labelProps={{
                                className: classes.retPenRadioLabel
                            }}
                        />
                    </Grid>

                    <Grid pc={1} className={classes.pensionGroup}>
                        <RadioGroup
                            disabled={locked}
                            name="Pensioner"
                            label="Pensioner"
                            options={PENSIONER_OPTIONS}
                            form={form}
                            className={classes.pensionRadio}
                            labelProps={{
                                className: classes.retPenRadioLabel
                            }}
                            fullWidth={false}
                        />
                        {form.getField('Pensioner') === 'Y' && (
                            <Select
                                disabled={locked}
                                name="PensionType"
                                options={PENSION_TYPE_OPTIONS}
                                form={form}
                                fullWidth={false}
                                className={classes.pensionSelect}
                                label="Pension Type"
                                InputLabelProps={{ shrink: true }}
                            />
                        )}
                    </Grid>
                </Grid>
                <Grid bucket>
                    <Grid pc={1}>
                        <RadioGroup
                            disabled={locked}
                            name="Aboriginal"
                            label="Aboriginal"
                            options={ABORIGINAL_OPTIONS}
                            form={form}
                            value={!form.getField('Aboriginal') ? 'N' : form.getField('Aboriginal')}
                            labelProps={{
                                className: classes.aboTorRadioLabel
                            }}
                        />
                    </Grid>

                    <Grid pc={1}>
                        <RadioGroup
                            disabled={locked}
                            name="TorresStrait"
                            label="Torres Strait Islander"
                            options={TORRES_OPTIONS}
                            form={form}
                            value={!form.getField('TorresStrait') ? 'N' : form.getField('TorresStrait')}
                            labelProps={{
                                className: classes.aboTorRadioLabel
                            }}
                        />
                    </Grid>

                    {this.renderPlaceOfBirthOptions()}
                </Grid>

                {this.renderPhotos()}
            </Grid>
        );
    }

    renderPlaceOfBirthOptions() {
        const { form, classes, locked } = this.props;
        const { placeOfBirthOption } = this.state;
        const yearMax = new Date().getFullYear();
        const yearMin = yearMax - 120;
        const yearPlaceholder = (yearMin + (yearMax - yearMin) / 2.6).toFixed(0);

        return (
            <Grid pc={1}>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <RadioGroup
                            disabled={locked}
                            labelProps={{
                                className: classes.aboTorRadioLabel
                            }}
                            label="Place of Birth"
                            options={PLACE_OF_BIRTH_OPTIONS}
                            value={placeOfBirthOption}
                            onChange={e => this.handleChangePlaceOfBirthOption(e)}
                        />
                    </Grid>
                </Grid>
                {placeOfBirthOption !== PLACE_OF_BIRTH_UNKNOWN && (
                    <Fragment>
                        <Grid container spacing={1}>
                            <Grid item xs={12} sm={4} md={4} lg={6} xl={4}>
                                <TextField
                                    disabled={locked}
                                    name="PlaceOfBirth1"
                                    label="City of Birth"
                                    InputLabelProps={{ shrink: true }}
                                    form={form}
                                />
                            </Grid>
                            {(placeOfBirthOption === PLACE_OF_BIRTH_AUSTRALIA && (
                                <Grid item xs={12} sm={4} md={4} lg={6} xl={4}>
                                    <Select
                                        disabled={locked}
                                        allowNone
                                        options={CONTACT_AUS_STATES}
                                        label="State/Territory of Birth"
                                        InputLabelProps={{ shrink: true }}
                                        form={form}
                                        name="PlaceOfBirthState"
                                    />
                                </Grid>
                            )) || (
                                <Fragment>
                                    <Grid item xs={12} sm={4} md={4} lg={6} xl={4}>
                                        <TextField
                                            disabled={locked}
                                            label="State/Province of Birth"
                                            InputLabelProps={{ shrink: true }}
                                            form={form}
                                            name="PlaceOfBirthState"
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4} md={4} lg={6} xl={4}>
                                        <TextField
                                            disabled={locked}
                                            label="Country of Birth"
                                            InputLabelProps={{ shrink: true }}
                                            form={form}
                                            name="PlaceOfBirthCountry"
                                            onBlur={e => this.handleChangePlaceOfBirthAddress(e.target.value)}
                                        />
                                    </Grid>
                                </Fragment>
                            )}
                        </Grid>
                    </Fragment>
                )}
                {placeOfBirthOption === PLACE_OF_BIRTH_OVERSEAS && (
                    <Fragment>
                        <br />
                        <Label text="Year entered Australia" htmlFor="text-DateEnteredAustralia" />
                        <Grid container spacing={1}>
                            {!form.getField('DateEnteredAustraliaUnknown') && (
                                <Grid item xs={6} sm={4}>
                                    <TextField
                                        disabled={locked}
                                        name="DateEnteredAustralia"
                                        type="number"
                                        placeholder={`Enter a year, ie ${yearPlaceholder}`}
                                        min={yearMin}
                                        max={yearMax}
                                        step={1}
                                        notFuture
                                        form={form}
                                    />
                                </Grid>
                            )}
                            <Grid item xs={6} sm={8}>
                                <Checkbox
                                    disabled={locked}
                                    name="DateEnteredAustraliaUnknown"
                                    form={form}
                                    label="Year Unknown"
                                    onChange={e => form.setField({ DateEnteredAustralia: null })}
                                />
                            </Grid>
                        </Grid>
                    </Fragment>
                )}
            </Grid>
        );
    }

    //if they have selected non-australia. but enter an australian address, we flip the toggle.
    handleChangePlaceOfBirthAddress({ PlaceOfBirthCountry }) {
        let { placeOfBirthOption } = this.state;

        if (placeOfBirthOption !== PLACE_OF_BIRTH_AUSTRALIA && PlaceOfBirthCountry === 'Australia') {
            this.setState({ placeOfBirthOption: PLACE_OF_BIRTH_AUSTRALIA });
        } else if (placeOfBirthOption === PLACE_OF_BIRTH_AUSTRALIA && PlaceOfBirthCountry !== 'Australia') {
            this.setState({ placeOfBirthOption: PLACE_OF_BIRTH_OVERSEAS });
        }
    }

    handleChangePlaceOfBirthOption(e) {
        const { form } = this.props;
        const { PlaceOfBirthCountry } = this.state;

        let newFormState = {
            DateEnteredAustralia: null,
            PlaceOfBirth1: null,
            PlaceOfBirthState: null,
            PlaceOfBirthCountry: null
        };

        if (e.target.value === PLACE_OF_BIRTH_AUSTRALIA) {
            newFormState.PlaceOfBirthCountry = 'Australia';
        } else if (e.target.value === PLACE_OF_BIRTH_OVERSEAS) {
            newFormState.PlaceOfBirthCountry = PlaceOfBirthCountry !== 'Australia' ? PlaceOfBirthCountry : null;
        } else if (e.target.value === PLACE_OF_BIRTH_UNKNOWN) {
            newFormState.PlaceOfBirth1 = 'Unknown';
        }

        form.setField(newFormState);
        this.setState({ placeOfBirthOption: e.target.value });
    }

    renderPhotos() {
        const { form, locked } = this.props;
        const photos = form.getField('Photos') || [];

        const memorialID = form.getField('MemorialPhoto.ID');

        return (
            <ValidationPlaceholder validationResult={form.getValidation('Photos', true)}>
                <Grid bucket container spacing={3}>
                    <Grid item xs={12}>
                        <Label>Photos</Label>
                        {photos && photos.length > 0 && (
                            <ImageList>
                                {photos.map((photo, i) => {
                                    const isMem = photo.ID === memorialID;

                                    return (
                                        <ImageListItem
                                            key={i}
                                            value={{ image: photo.AbsoluteLink, label: photo.Name }}
                                            onClick={() => this.setState({ selectedPhoto: photo })}
                                            onDelete={locked ? null : () => this.removeUpload(i, photo.ID)}
                                            title={joinDefined([isMem ? 'Memorial Book Photo' : ''], ' and ')}
                                            customActions={
                                                locked
                                                    ? null
                                                    : [
                                                          {
                                                              title:
                                                                  (!!isMem ? 'Selected' : 'Select') +
                                                                  ' as Memorial Book Photo',
                                                              icon: <MemorialBookIcon />,
                                                              onClick: () => {
                                                                  form.setField({
                                                                      MemorialPhoto: !!isMem ? { ID: 0 } : photo
                                                                  });
                                                              },
                                                              isActive: !!isMem
                                                          }
                                                      ]
                                            }
                                        />
                                    );
                                })}
                            </ImageList>
                        )}
                    </Grid>
                    <Grid item xs={12}>
                        {!locked && this.renderNewPhoto()}
                    </Grid>
                </Grid>
            </ValidationPlaceholder>
        );
    }

    renderNewPhoto() {
        const { form } = this.props;
        return (
            <FileUpload
                label={'Upload Image'}
                accept={'image/*'}
                buttonOnly={true}
                folderPath={`/documents/prearrangements/${form.getField('ID')}`}
                onComplete={({ uploadFile }) => this.onFileUploaded(uploadFile)}
            />
        );
    }

    onFileUploaded({ id, url, filename }) {
        const { form } = this.props;
        const Photos = form.getField('Photos') || [];

        Photos.push({
            ID: id,
            AbsoluteLink: url,
            Name: getFileName(filename)
        });

        form.setField({ Photos });
    }

    removeUpload(index, id) {
        const { form } = this.props;

        if (id === form.getField('MemorialPhoto.ID')) form.setField({ MemorialPhoto: { ID: 0 } });

        const Photos = form.getField('Photos');
        Photos.splice(index, 1);
        form.setField({ Photos });
    }
}

const styles = ({ spacing }) => ({
    noColumn: { margin: `-${spacing(3)} ${spacing(1)} ${spacing(3)} ${spacing(1)}` },
    column: {
        '& > *': {
            marginBottom: -12
        }
    },
    placeOfDeathHeader: {
        display: 'flex',
        marginBottom: -24,
        alignItems: 'flex-end'
    },
    alignWithFloatingLabel: {
        marginTop: 8
    },
    placeOfDeathLabel: {
        flex: '1 1 auto'
    },
    pensionGroup: {
        display: 'flex'
    },
    pensionRadio: {
        flex: '0 1 auto'
    },
    pensionSelect: {
        flex: '1 0 auto',
        maxWidth: 180,
        alignSelf: 'start'
    },
    retPenRadioLabel: {
        minWidth: 70
    },
    aboTorRadioLabel: {
        flex: '1 1 auto',
        maxWidth: 200
    },
    peeGap: {
        marginTop: 6
    }
});

export default withStyles(styles)(Identity);
